import {Component, OnInit} from '@angular/core';
import {ProductsArticleService} from './products-article.service';
import {ActivatedRoute, Params} from '@angular/router';
import {ProductsArticle} from './products-article';
import {Lots} from './lots';
import {StocksService} from './stocks.service';
import {ProductsCategoryService} from './products-category.service';
import {ProductsCategory} from './products-category';

@Component({
    selector: 'receip-stock',
    styleUrls: ['./styles/products-list.component.css'],
    templateUrl: './templates/receip-stock.component.html',
    providers: [ProductsArticleService, ProductsCategoryService, StocksService]
})

export class ReceipStock {
    name = '';
    serial_value = "Entrer le numéro de série";
    serial_management = "";
    lot_management = "";

    id_article: number;
    quantity: string = '0';
    lot_name: string;
    lot_name_select: string;
    lot: string;
    serial_number: string;

    serial_number_disabled: boolean = true;
    lot_disabled: boolean = true;
    lot_select_disabled: boolean = true;
    qte_disabled: boolean = true;
    valid_bt: boolean = true;

    cat_list: ProductsCategory[];
    prod_list: ProductsArticle[];
    lot_list: Lots[];

    internal_code: string;
    reference_code: string;
    name_art: string;
    category: string;
    already_in: boolean = false;

    public list: string[];



    constructor(private products_article_service: ProductsArticleService, private products_category_service: ProductsCategoryService, private lots_service: StocksService, private route: ActivatedRoute) {
    }

    GetArticlesList(): void {
        this.products_article_service.GetArticlesList().then(prod_list => {this.GetArticle_cb(prod_list)});

    }

    GetLotsList(id_article: number): void {
        this.lots_service.GetLotsList(id_article).then(lot_list => this.lot_list = lot_list);

    }

    ReceipStock(): void {
        this.lot = this.lot_name;

        if (this.quantity === "") {
            this.quantity = '0';
        }
        if (this.lot_name === "") {
            this.lot = this.lot_name_select;
        }

        this.lots_service.ReceipStoks(this.id_article, this.quantity, this.lot, this.serial_number).then(result => {this.prod_list = result['list']; if (result['result'] === 'KO') {this.already_in = true} });
        this.InitForm();

        this.name = "";
        this.serial_management = "";
        this.lot_management = "";
    }

    Search(): void {
        console.log("search");
        if ((this.internal_code == undefined) && (this.reference_code == undefined) && (this.name_art == undefined) && (this.category == undefined)) {
            this.GetArticlesList();
        } else {
            this.products_article_service.Search(this.internal_code, this.reference_code, this.name_art, this.category).then(prod_list => this.prod_list = prod_list);

        }
    }

    GetCategoriesList(): void {
        this.products_category_service.GetCategoriesList().then(cat_list => this.cat_list = cat_list);

    }

    AllArticles(): void {
        this.GetArticlesList();
    }

    SetReceipOperation(product: ProductsArticle): void {
        this.InitForm();
        this.GetLotsList(product.id_article);

        this.name = product.name;
        this.qte_disabled = false;

        this.valid_bt = false;
        this.id_article = product.id_article;

        if (product.managed_by_serial === 'UNMANAGED_BY_SERIAL' || product.managed_by_serial === 'OUT') {
            this.serial_number_disabled = true;
            this.serial_value = "Non gérer par numéro de série";
        }
        else {
            this.quantity = '1';
            this.qte_disabled = true;
            this.serial_number_disabled = false;
            this.serial_value = "Entrer le numéro de série";
            this.SerialNumberCtl();
        }
        if (product.managed_by_lot === '0') {
            this.lot_disabled = true;
            this.lot_select_disabled = true;

        } else {
            this.lot_disabled = false;
            this.lot_select_disabled = false;
        }

        this.ManagementInfos(product);
    }

    ManagementInfos(product: ProductsArticle): void {
        if (product.managed_by_lot === '0') {
            this.lot_management = '( Non géré par lot -';
        } else if (product.managed_by_lot === '1') {
            this.lot_management = '( Géré par lot -';
        }
        if (product.managed_by_serial === 'OUT') {
            this.serial_management = 'géré par numéro de série en sortie )';
        } else if (product.managed_by_serial === 'IN_OUT') {
            this.serial_management = 'géré par numéro de série en entrée / sortie )';
        } else if (product.managed_by_serial === 'UNMANAGED_BY_SERIAL') {
            this.serial_management = 'non géré par numéro de série )';
        }
    }

    ChoisedArticle(product: ProductsArticle): void {
        this.already_in = false;
        this.SetReceipOperation(product);
        this.ManagementInfos(product);
    }

    InitForm(): void {
        this.quantity = '0';
        this.lot_name = "";
        this.lot_name_select = "";
        this.lot = "";
        this.serial_number = "";

        this.name = 'Article Infos';
        this.serial_number_disabled = true;
        this.lot_disabled = true;
        this.lot_select_disabled = true;
        this.qte_disabled = true;
        this.valid_bt = true;
    }

    LotKeyUpEvent(): void {

        if (this.lot_name !== "") {
            this.lot_select_disabled = true;
            this.lot_name_select = "";
        }
        else {
            this.lot_select_disabled = false;
        }
    }

    SerialNumberCtl(): void {
        if (this.serial_number === "") {
            this.valid_bt = true;
        }
        else {
            this.valid_bt = false;
        }
    }

    load_article(id: number): void {
        for (let i = 0; i < this.prod_list.length; i++) {
            if (this.prod_list[i].id_article == id) {
                this.SetReceipOperation(this.prod_list[i]);
            }
        }
    }

    GetArticle_cb(prod_list: ProductsArticle[]): void {
        this.prod_list = prod_list;
        this.route.params.subscribe((params: Params) => {
            let id = params['id'];

            if (id !== undefined) {
                this.load_article(parseInt(id));
            }
        });
    }

    NumericalTest(quantity: string): void {
        if (isNaN(Number(quantity))) {
            this.quantity = "0";
        }
    }

    ngOnInit(): void {
        this.GetArticlesList();
        this.GetCategoriesList();
    }

}



// WEBPACK FOOTER //
// ./src/app/receip-stock.component.ts